import { addDuration, isBefore, startOfDay } from '@repo/common';

import { TimeFormat } from '../../../constants/timezone';
import { formatTimeForDisplay } from '../../../utils/time/date-time';
import type { TimeRange } from '../types/time';

export const isOverlapping = (range1: TimeRange, range2: TimeRange): boolean => {
  return range1.end > range2.start && range1.start < range2.end;
};

export interface TimeOption {
  value: string;
  label: string;
}

export const generateTimeOptions = (
  start: number,
  end: number,
  interval: number,
  timeFormat: TimeFormat,
): TimeOption[] => {
  const options: TimeOption[] = [];
  const startTime = addDuration(startOfDay(new Date()), start, 'hour');
  const endTime = addDuration(startOfDay(new Date()), end, 'hour');
  const userTimzone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  for (let time = startTime; isBefore(time, endTime); time = addDuration(time, interval, 'minute')) {
    options.push({
      value: formatTimeForDisplay(time, userTimzone, TimeFormat['24hr']),
      label: formatTimeForDisplay(time, userTimzone, timeFormat),
    });
  }

  return options;
};
